// Nama hari mengikuti konvensi Date.getDay() JS: 0=Minggu ... 6=Sabtu
export const DAY_NAMES = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];

function toMinutes(hhmm) {
  const [h, m] = (hhmm || '00:00').split(':').map(Number);
  return h * 60 + (m || 0);
}

function dayInRange(day, start, end) {
  if (start <= end) return day >= start && day <= end;
  return day >= start || day <= end; // rentang yang membungkus akhir pekan, mis. Sabtu-Senin
}

/** Teks jam operasional untuk ditampilkan, mis. "Senin - Jumat: 08:00 - 17:00" */
export function formatOperatingHours(settings) {
  const start = Number(settings.hari_mulai ?? 1);
  const end = Number(settings.hari_selesai ?? 5);
  const jamBuka = settings.jam_buka || '08:00';
  const jamTutup = settings.jam_tutup || '17:00';
  const dayLabel = start === end ? DAY_NAMES[start] : `${DAY_NAMES[start]} - ${DAY_NAMES[end]}`;
  return `${dayLabel}: ${jamBuka} - ${jamTutup}`;
}

/** Status buka/tutup real-time berdasarkan hari & jam yang dikonfigurasi di Pengaturan Situs */
export function isOpenNow(settings) {
  const start = Number(settings.hari_mulai ?? 1);
  const end = Number(settings.hari_selesai ?? 5);
  const jamBuka = settings.jam_buka || '08:00';
  const jamTutup = settings.jam_tutup || '17:00';

  const now = new Date();
  const day = now.getDay();
  const minutesNow = now.getHours() * 60 + now.getMinutes();

  if (!dayInRange(day, start, end)) return false;
  return minutesNow >= toMinutes(jamBuka) && minutesNow < toMinutes(jamTutup);
}
